import type { PermissaoDominioDto } from '@/types/escritorio/permissaoDominioTypes';
import { createSlice } from '@reduxjs/toolkit';
import {
  atualizarPermissaoDominio,
  criarPermissaoDominio,
  listarPermissoesDominio,
  removerPermissaoDominio,
} from './actions';

interface PermissoesDominioState {
  permissoes: PermissaoDominioDto[];
  loading: boolean;
  error: string | null;
}

const initialState: PermissoesDominioState = {
  permissoes: [],
  loading: false,
  error: null,
};

const permissoesDominioSlice = createSlice({
  name: 'permissoesDominio',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(listarPermissoesDominio.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(listarPermissoesDominio.fulfilled, (state, action) => {
        state.loading = false;
        state.permissoes = action.payload;
      })
      .addCase(listarPermissoesDominio.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(criarPermissaoDominio.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(criarPermissaoDominio.fulfilled, (state, action) => {
        state.loading = false;
        state.permissoes.push(action.payload);
      })
      .addCase(criarPermissaoDominio.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(atualizarPermissaoDominio.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(atualizarPermissaoDominio.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.permissoes.findIndex(
          (p) => p.usuarioId === action.payload.usuarioId && p.dominio === action.payload.dominio,
        );
        if (index !== -1) {
          state.permissoes[index] = action.payload;
        }
      })
      .addCase(atualizarPermissaoDominio.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(removerPermissaoDominio.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removerPermissaoDominio.fulfilled, (state, action) => {
        state.loading = false;
        state.permissoes = state.permissoes.filter(
          (p) =>
            !(p.usuarioId === action.payload.usuarioId && p.dominio === action.payload.dominio),
        );
      })
      .addCase(removerPermissaoDominio.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default permissoesDominioSlice.reducer;
